export const boxShadows = {
  default: `0px 1px 1px 0px rgba(20, 20, 20, 0.20)`,
  defaultPrimary: '0px 1px 8px 0px rgba(33, 166, 150, 0.24)',
  hover: `0px 1px 8px 0px rgba(20, 20, 20, 0.12)`,
  hoverPrimary: `0px 8px 12px 0px rgba(33, 166, 150, 0.24)`,
}
